import React, { useEffect, useState, useRef, useCallback } from "react";
import { apiClient } from "../../lib/api";
import { useAppStore } from "../../store/useAppStore";
import SupportIncidentModal from "./components/SupportIncidentModal";

// IMPORTAR LOS SUBCOMPONENTES
import ConversationList from "./components/ConversationList";
import ChatArea from "./components/ChatArea";
import ReservationDetails from "./components/ReservationDetails";

const MensajeriaPage = () => {
  // useState
  const [messages, setMessages] = useState<any[]>([]);
  const [description1, setDescription1] = useState<any>(null);
  const [description2, setDescription2] = useState<any>(null);
  const [messageSend, setMessageSend] = useState("");
  const [conversation, setConversation] = useState<any[]>([]);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [parametricIncidentTypes, setParametricIncidentTypes] = useState<any[]>([]);
  const [parametricIncidentResponsibles, setParametricIncidentResponsibles] = useState<any[]>([]);
  const [dataPreviewFinal, setDataPreviewFinal] = useState<any>(null);
  const [selectedConversation, setSelectedConversation] = useState<any>(null);
  const [detailsView, setDetailsView] = useState("");
  const [incidentType, setIncidentType] = useState<any>(null);
  const [responsible, setResponsible] = useState<any>(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isLoadingConversations, setIsLoadingConversations] = useState(true);
  const [isSending, setIsSending] = useState(false);

  // Estados Responsivos para Mobile
  const [activeMobileView, setActiveMobileView] = useState<'list' | 'chat'>('list');
  const [isDetailsOpenMobile, setIsDetailsOpenMobile] = useState(false);

  // Estados para el Modal
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [supportTargetId, setSupportTargetId] = useState("");
  const [supportTargetName, setSupportTargetName] = useState("");
  const [supportTargetRole, setSupportTargetRole] = useState("");

  // store
  const addNotification = useAppStore((state) => state.addNotification);

  // useRef
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const isFetchingConversations = useRef(false);
  const isFetchingParametrics = useRef(false);

  // store
  const user = useAppStore((state) => state.user);

  // Función para hacer scroll al final
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // functions
  async function openChat(conv: any) {
    setSelectedConversation(conv);
    setIsLoadingDetails(true);
    
    // Cambio Responsivo: Activamos la vista del chat en mobile
    setActiveMobileView('chat');
    
    try {
      const response: any = await apiClient.get(
        `Support/Conversation/${conv.conversationId}/Messages?orderBy=dateAsc`,
      );
      if (response.statusCode == "200" && response.data) {
        setMessages(response?.data);

        // SE OMITE EL FORMULARIO DE INCIDENTE Y SE MUESTRA DIRECTAMENTE EL DETALLE
        setDetailsView("chat_1");
        setIncidentType(null);
        setResponsible(null);
      }
    } catch (error) {
      console.error("Error fetching conversation details:", error);
    } finally {
      setIsLoadingDetails(false);
    }

    try {
      const response: any = await apiClient.get(`GetProfileByUserId/${conv?.userIdOneNavigation?.userId}`);
      if (response.statusCode === "200" && response.data) {
        setUserProfile(response.data);
      }
    } catch (error: any) {
      console.error("Error fetching conversation details:", error);
    }
  }

  const reFetchMessages = useCallback(async () => {
    if (!selectedConversation?.conversationId) return;

    try {
      const response: any = await apiClient.get(
        `Support/Conversation/${selectedConversation.conversationId}/Messages?orderBy=dateAsc`
      );
      if (response.statusCode === "200" && response.data) {
        setMessages(response.data);
      }
    } catch (error: any) {
      console.error("Error fetching messages:", error);
    }
  }, [selectedConversation?.conversationId]);

  const handleSendMessage = async () => {
    if (!messageSend.trim() || isSending) return;
    setIsSending(true);
    try {
      const response: any = await apiClient.post(
        `Messaging/Conversations/${selectedConversation?.conversationId}/Messages`,
        {
          bookId: selectedConversation?.bookId ?? 0,
          messageTypeId: 1,
          body: messageSend,
        },
      );
      if (response.statusCode === "200" && response.data) {
        reFetchMessages();
        setMessageSend("");
      } else {
        addNotification({
          type: "error",
          message: response?.resultError?.message || "Error al enviar el mensaje"
        });
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsSending(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  function closeChat() {
    // Cambio Responsivo: Volver a la vista de lista en mobile
    setActiveMobileView('list');
  }

  function closeDetails() {
    setIsDetailsOpenMobile(false);
  }

  // Función que busca si existe un chat paralelo para este mismo incidente
  const getRelatedIncidentConversation = () => {
    if (!selectedConversation?.tbComplaints || selectedConversation.tbComplaints.length === 0) {
      return null;
    }

    const currentComplaintId = selectedConversation.tbComplaints[0].complaintId;
    const currentConversationId = selectedConversation.conversationId;

    const relatedChat = conversation.find((conv: any) => {
      if (conv.conversationId === currentConversationId) return false;

      return conv.tbComplaints?.some(
        (complaint: any) => complaint.complaintId === currentComplaintId
      );
    });

    return relatedChat;
  };

  const relatedChat = getRelatedIncidentConversation();

  // Función para obtener mensajes sin caché
  const fetchConversation = useCallback(async () => {
    if (isFetchingConversations.current) return;

    isFetchingConversations.current = true;
    setIsLoadingConversations(true);

    try {
      const response: any = await apiClient.get(`Support/Conversation`);
      if (response.statusCode === "200" && response.data) {
        setConversation(response?.data);
      } else {
        console.error("Error fetching messages:", response);
      }
    } catch (error: any) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoadingConversations(false);
      isFetchingConversations.current = false;
    }
  }, []);

  const handleChangeDetailsView = async (view: string) => {
    if (view == "resumeIncidentType") {
      try {
        const response: any = await apiClient.get(`Parametrics/Incident/Responsibles/${responsible?.responsiblePartyId}/Types`);
        if (response.statusCode === "200" && response.data) {
          setParametricIncidentTypes(response.data);
          setDetailsView("confirmation3");
        } else {
          addNotification({
            type: "error",
            message: response?.resultError?.message
          });
        }
      } catch (error: any) {
        console.error("Error fetching Incident/Responsibles details:", error);
      }
    }
    else {
      setDetailsView(view);
    }
  }

  // Limpiar el campo de mensaje cuando se cambia de conversación
  useEffect(() => {
    setMessageSend("");
  }, [selectedConversation?.conversationId]);

  const handlePreviewIncident = async () => {
    if (responsible?.code != "DESIST" && responsible?.code != "") {
      try {
        const response: any = await apiClient.post(`Incident/PreviewFinancialApplication`,
          {
            complaintId: selectedConversation?.tbComplaints?.[0]?.complaintId,
            bookId: selectedConversation?.booking?.bookId,
            responsibleId: responsible?.responsiblePartyId,
            incidentTypeId: incidentType?.incidentTypeId,
            terminationDate: selectedConversation?.tbComplaints?.[0]?.complaintDate,
          });

        if (response.statusCode === "200" && response.data) {
          setDetailsView("confirmation4");
          setDataPreviewFinal(response.data);
        } else {
          addNotification({
            type: "error",
            message: response?.resultError?.message || "Error al consultar incidente"
          });
        }
      } catch (error) {
        console.error("Error previa finalizacion:", error);
      }
    } else {
      addNotification({
        type: "info",
        message: "Debe seleccionar un responsable para continuar"
      });
    }
  }

  const resolverAndTerminate = async () => {
    try {
      const response: any = await apiClient.post(`Incident/ResolverAndTerminate`,
        {
          complaintId: selectedConversation?.tbComplaints?.[0]?.complaintId,
          responsibleId: responsible?.responsiblePartyId,
          incidentTypeId: incidentType?.incidentTypeId ?? null,
          description: description1 ?? "",
          verifiedEvidence: description2 ?? "",
          terminationDate: selectedConversation?.tbComplaints?.[0]?.complaintDate,
        });

      if (response.statusCode === "200" && response.data) {
        setDetailsView("end");
        fetchConversation();
        addNotification({
          type: "success",
          message: "Incidente resuelto y terminado exitosamente"
        });
      } else {
        addNotification({
          type: "error",
          message: response?.resultError?.message || "Error al resolver y terminar el incidente"
        });
      }
    } catch (error) {
      console.error("Error al resolver y terminar el incidente:", error);
    }
  }

  const fetchparametrics = useCallback(async () => {
    if (isFetchingParametrics.current) return;
    isFetchingParametrics.current = true;

    try {
      if (parametricIncidentResponsibles.length === 0) {
        const params: any = await apiClient.get(`Parametrics/Incident/Responsibles`);
        if (params.statusCode === "200" && params.data) {
          setParametricIncidentResponsibles(params.data);
        }
      }
    } catch (error) {
      console.error("Error fetching params:", error);
    } finally {
      isFetchingParametrics.current = false;
    }
  }, [parametricIncidentResponsibles.length]);

  //  hooks
  useEffect(() => {
    fetchConversation();
    fetchparametrics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Scroll al final cuando cambien los mensajes
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (!selectedConversation?.conversationId) return;

    const intervalId = setInterval(() => {
      reFetchMessages();
    }, 5000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reFetchMessages]);

  return (
    <div className="h-full -m-8 lg:-m-6 rounded-card overflow-hidden">
      <main className="flex-1 w-full lg:max-w-full lg:mx-auto lg:px-1">
        {/* Contenedor Flex principal. 'relative' nos sirve por si hay paneles superpuestos en móvil */}
        <div className="flex h-[calc(100vh-56px)] md:h-[calc(100vh-144px)] lg:rounded-card overflow-hidden lg:border lg:border-neutral-border relative">
          
          <ConversationList
            className={`${activeMobileView === 'list' ? 'flex' : 'hidden'} lg:flex w-full lg:w-[400px]`}
            isLoadingConversations={isLoadingConversations}
            conversation={conversation}
            selectedConversation={selectedConversation}
            openChat={openChat}
            user={user}
          />

          <ChatArea
            className={`${activeMobileView === 'chat' ? 'flex' : 'hidden'} lg:flex flex-1`}
            selectedConversation={selectedConversation}
            closeChat={closeChat}
            user={user}
            messages={messages}
            messagesEndRef={messagesEndRef}
            messageSend={messageSend}
            setMessageSend={setMessageSend}
            handleKeyPress={handleKeyPress}
            handleSendMessage={handleSendMessage}
            isSending={isSending}
            relatedChat={relatedChat}
            openChat={openChat}
            setSupportTargetId={setSupportTargetId}
            setSupportTargetRole={setSupportTargetRole}
            setSupportTargetName={setSupportTargetName}
            setShowSupportModal={setShowSupportModal}
          />

          <ReservationDetails
            className={`fixed lg:relative top-0 right-0 bottom-0 lg:top-auto lg:right-auto lg:bottom-auto w-full lg:w-[400px] z-50 lg:z-auto transition-transform duration-300 ${isDetailsOpenMobile ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}`}
            detailsView={detailsView}
            closeDetails={closeDetails}
            isLoadingDetails={isLoadingDetails}
            parametricIncidentResponsibles={parametricIncidentResponsibles}
            responsible={responsible}
            setResponsible={setResponsible}
            handleChangeDetailsView={handleChangeDetailsView}
            parametricIncidentTypes={parametricIncidentTypes}
            setIncidentType={setIncidentType}
            description1={description1}
            setDescription1={setDescription1}
            handlePreviewIncident={handlePreviewIncident}
            dataPreviewFinal={dataPreviewFinal}
            description2={description2}
            setDescription2={setDescription2}
            resolverAndTerminate={resolverAndTerminate}
            selectedConversation={selectedConversation}
            user={user}
            userProfile={userProfile}
            isDetailsOpenMobile={isDetailsOpenMobile}
            
            // Props para el modal
            setSupportTargetId={setSupportTargetId}
            setSupportTargetRole={setSupportTargetRole}
            setSupportTargetName={setSupportTargetName}
            setShowSupportModal={setShowSupportModal}
          />

        </div>

        {/* COMPONENTE MODAL */}
        <SupportIncidentModal
          isOpen={showSupportModal}
          onClose={() => setShowSupportModal(false)}
          selectedConversation={selectedConversation}
          recipientId={supportTargetId}
          recipientName={supportTargetName}
          recipientRole={supportTargetRole}
          onSuccess={() => fetchConversation()}
        />

      </main>
    </div>
  );
};

export default MensajeriaPage;